import { PUBLIC_CHAIN } from '$env/static/public';
import type { Address } from '$types/address';

export const TOKEN_ADDRESSES_ENTITIES: { [key: string]: Address } =
  PUBLIC_CHAIN === 'GNOSIS'
    ? {
        eure: '0x420CA0f9B9b604cE0fd9C18EF134C705e5Fa3430',
        gbpe: '0x8E34bfEC4f6Eb781f9743D9b4af99CD23F9b7053',
        wxdai: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
        gno: '0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb',
        usdc: '0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0',
        'usdc-old': '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
        weth: '0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1',
        wbtc: '0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252',
        sdai: '0xaf204776c7245bF4147c2612BF6e5972Ee483701',
      }
    : {
        eure: '0x7a47605930002CC2Cd2c3c408D1F33fc2a18aB71',
        gbpe: '0x436AF2954BB436b6821Ab401112092e14CDBd546',
        wxdai: '0x18c8a7ec7897177E4529065a7E7B0878358B3BfF',
        gno: '0x19C653Da7c37c66208fbfbE8908A5051B57b4C70',
      };

export const MONERIUM_REMAPPINGS: { [key: Address]: Address } = {
  '0xcB444e90D8198415266c6a2724b7900fb12FC56E': '0x420CA0f9B9b604cE0fd9C18EF134C705e5Fa3430',
  '0x5Cb9073902F2035222B9749F8fB0c9BFe5527108': '0x8E34bfEC4f6Eb781f9743D9b4af99CD23F9b7053',
};

export const CRC_TOKEN_BUY_SELL_ADDRESS = '0x1a5a62AE01EaD54e2Ead4F58d9B24643AeDc5C90';
